import {
  CategoryIdEnum,
  LanguageEnum,
  QueryReadCategoriesTranslateArgs,
  ReadCategoriesTranslateType
} from '@/generated/graphql.mia'
import { READ_CATEGORIES_TRANSLATE } from '@/graphql/mia/queries/readCategories'
import { useQuery } from '@vue/apollo-composable'
import { defineStore } from 'pinia'
import { computed, ref } from 'vue'
import { useI18n } from 'vue-i18n'

export const useCategoriesStore = defineStore('categoriesStore', () => {
  const { locale } = useI18n()

  const activeCategory = ref<CategoryIdEnum>(CategoryIdEnum.General)

  const { result: categoriesResult, onError: onReadCategoriesTranslateError } = useQuery<
    { readCategoriesTranslate: ReadCategoriesTranslateType },
    QueryReadCategoriesTranslateArgs
  >(
    READ_CATEGORIES_TRANSLATE,
    {
      categoriesTranslateInput: {
        languageEnum: locale.value.toLocaleUpperCase() as LanguageEnum
      }
    },
    {
      clientId: 'mia'
    }
  )

  onReadCategoriesTranslateError(() => {
    console.error('Error while fetching categories translations')
  })

  const categoriesTranslations = computed(() => {
    if (typeof categoriesResult.value?.readCategoriesTranslate.data === 'undefined') {
      return []
    }

    return categoriesResult.value.readCategoriesTranslate.data!
  })

  return { categoriesTranslations, activeCategory }
})
